import React from 'react';
import PropTypes from 'prop-types';
import { EditableContent } from '@storable/canaveral-rte';
import CurrentSiteContext from 'modules/react/contexts/CurrentSiteContext';
import MediaLibrary from '../MediaLibrary';

const propTypes = {
  editing: PropTypes.bool,
  editorKey: PropTypes.string.isRequired,
  fieldReplacements: PropTypes.objectOf(PropTypes.shape({
    label: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired,
  })),
  onChange: PropTypes.func,
  onDismiss: PropTypes.func,
  onSave: PropTypes.func,
  rawContentState: PropTypes.shape({
    blocks: PropTypes.arrayOf(PropTypes.object).isRequired,
    entityMap: PropTypes.object,
  }),
};

const defaultProps = {
  editing: undefined,
  fieldReplacements: {},
  onChange: undefined,
  onDismiss: undefined,
  onSave: undefined,
  rawContentState: undefined,
};

class EditableRichText extends React.Component {
  onSave = (rawContentState) => {
    const { onSave } = this.props;
    if (typeof onSave === 'function') {
      onSave({ rawContentState });
    }
  }
  render() {
    const {
      editing, editorKey, fieldReplacements, onChange, onDismiss, onSave, rawContentState,
    } = this.props;

    // Mongo will strip the entityMap if it's empty and then it gets passed down
    // as `null` instead of `undefined`, so it doesn't get replaced with default
    // props.
    if (rawContentState) {
      const { entityMap } = rawContentState;
      rawContentState.entityMap = entityMap || {};
    }
    return (
      <CurrentSiteContext.Consumer>
        {({ theme: { fonts, colors } }) => {
          const formattedFonts = fonts.primary.name && fonts.secondary.name ? {
            primary: {
              label: fonts.primary.name,
              value: fonts.primary.name,
            },
            secondary: {
              label: fonts.secondary.name,
              value: fonts.secondary.name,
            },
          } : {};

          return (
            <EditableContent
              colors={colors}
              editing={editing}
              onChange={onChange}
              editorKey={editorKey}
              onDismiss={onDismiss}
              fonts={formattedFonts}
              rawContentState={rawContentState}
              fieldReplacements={fieldReplacements}
              filesModalComponentClass={MediaLibrary}
              onSave={onSave ? this.onSave : undefined}
            />
          );
        }}
      </CurrentSiteContext.Consumer>
    );
  }
}

EditableRichText.propTypes = propTypes;
EditableRichText.defaultProps = defaultProps;

export default EditableRichText;
